import React from 'react';
import { Button, Grid, Switch, Typography } from '@mui/material';
import { CustomDatePicker, CustomTextField, CustomInputLabel, CustomButton, InputProps, StyledCard, StyledCardTitle, FlexDiv } from 'custom/components';
import developerStyles from './developer.module.css';
import styles from '../../../custom/style.module.css';
import dayjs from 'dayjs';

const Developer = (props) => {
  const getLable = (key) => {
    switch (key) {
      case 'ffm_flight_no':
        return 'FFM Flight No';
      case 'ffm_flight_date':
        return 'FFM Flight Date';
      case 'ffm_edit':
        return 'FFM Edit';
      case 'buildup':
        return 'Buildup Tab && Loading Accessories';
      case 'import':
        return 'Import Notification';
      case 'service':
        return 'Service Catalog';
      case 'statistics_summary':
        return 'Statistics Summary';
      case 'doc_fwb':
        return 'Doc FWB';
      case 'manifest_date':
        return 'List by Flight Date';
      default:
        return key;
    }
  };

  const getDesc = (key) => {
    switch (key) {
      case 'ffm_flight_no':
        return 'Enable/Disable FFM Flight No validation FFM upload in Flight Folder';
      case 'ffm_flight_date':
        return 'Enable/Disable FFM Flight Date validation FFM upload in Flight Folder';
      case 'buildup':
        return 'Enable/Disable Buildup Tab in Flight Folder and Export operation in admin';
      case 'import':
        return 'Enable/Disable Import Notification in Flight Folder and Inport operation in admin';
      case 'service':
        return 'Enable/Disable Service Catalog Tab in admin';
      case 'statistics_summary':
        return 'Enable/Disable Statistics Summary';
      case 'doc_fwb':
        return 'Enable/Disable AWB Viewer in navigation and Docs Stream for all users';
      case 'manifest_date':
        return 'List by Flight Date';
      default:
        return '';
    }
  };

  const companySettings = props.config.filter((item) => item.companyId && !item.stationId && item.key !== 'mail_bounce' && item.key !== 'doc_fwb');
  const docFwb = props.config.find((item) => item.key === 'doc_fwb') || {
    id: 'doc_fwb',
    key: 'doc_fwb',
    value: { data: 'false' },
  };
  companySettings.push(docFwb);

  const getStatus = (...keys) => {
    const status = keys.find((key) => props.progress?.[key]);
    return status ? props.progress[status] : '-';
  };

  const userSections = [
    {
      title: 'Authorized Users',
      list: props.userList
    },
    {
      title: 'Flight Reports Approvers',
      list: props.approverList
    },
    {
      title: 'Non Commercial Contract Importers',
      list: props.nonCommercialList
    }
  ];

  const adminImports = [
    {
      key: 'airlines',
      title: 'Airlines',
      onClick: props.importAirlines
    },
    {
      key: 'products',
      title: 'Products',
      onClick: props.importProducts
    },
    {
      key: 'checklists',
      title: 'Checklists',
      onClick: props.importChecklists
    },
    {
      key: 'contracts',
      title: 'Contracts',
      onClick: props.importContracts
    }
  ];

  return (
    <div className={developerStyles.page}>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle>Flight Folder (Company Level)</StyledCardTitle></FlexDiv>
            <div className={developerStyles.card}>
              <div className={developerStyles.switchList}>
                {companySettings.map((item, index) => (
                  <div key={index} className={developerStyles.switchRow}>
                    <div>
                      <Typography component='h3' className={developerStyles.rowTitle}>{getLable(item.key)}</Typography>
                      <Typography component='p' className={developerStyles.rowDescription}>{getDesc(item.key)}</Typography>
                    </div>
                    <Switch
                      name={item.id}
                      defaultChecked={item?.value?.data ? item.value.data === 'true' : false}
                      onChange={props.onChange}
                    />
                  </div>
                ))}
              </div>
            </div>
          </StyledCard>
        </Grid>

        <Grid item xs={12} lg={6}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle>Flight Data API (Global)</StyledCardTitle></FlexDiv>
            <div className={developerStyles.card}>
              <div className={developerStyles.switchList}>
                {props.stations.map((item, index) => (
                  <div key={index} className={developerStyles.switchRow}>
                    <Typography component='h3' className={developerStyles.rowTitle}>{getLable(item)}</Typography>
                    <Switch
                      name={item}
                      defaultChecked={!!props.config?.find((c) => c.key === 'flight_api' && c.value && c.value?.includes(item))}
                      onChange={props.onChangeStation}
                    />
                  </div>
                ))}
              </div>
            </div>
          </StyledCard>
        </Grid>


        {userSections.map((section) => (
          <Grid item xs={12} md={4} key={section.title}>
            <StyledCard className={styles.h100}>
              <FlexDiv><StyledCardTitle>{section.title}</StyledCardTitle></FlexDiv>
              <div className={developerStyles.card}>
                <ul className={developerStyles.userList}>
                  {section.list.map((item, index) => (
                    <li key={index} className={developerStyles.userItem}>{item.username}</li>
                  ))}
                </ul>
              </div>
            </StyledCard>
          </Grid>
        ))}

        <Grid item xs={12}>

          <StyledCard className={developerStyles.card}>
            <FlexDiv><StyledCardTitle>Import From Production</StyledCardTitle></FlexDiv>
            <div className={developerStyles.importBlock}>
              <Typography component='h3' className={developerStyles.blockTitle}>Admin Imports</Typography>
              <Grid container spacing={2} className={developerStyles.importGrid}>
                {adminImports.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={12/4} key={item.key}>
                    <div className={developerStyles.importRow}>
                      <Typography component='h4' variant='h4'>{item.title}</Typography>
                      <Button size='small' variant='contained' onClick={item.onClick}>Import</Button>
                      <p className={developerStyles.status}>Status: <span>{getStatus(item.key)}</span></p>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>

            <div className={developerStyles.importBlock}>
              <Typography component='h3' className={developerStyles.blockTitle}>Flights</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='airline'>Airline</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='airline'
                      name='airline'
                      value={props.searchOptions.airline}
                      onChange={(e) => props.handleChange(e, 'airline')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='from'>From</CustomInputLabel>
                    <CustomDatePicker
                      slotProps={{
                        textField: {
                          ...InputProps,
                          id: 'from',
                          placeholder: 'Date',
                          fullWidth: true
                        },
                      }}
                      format='DD MMM YYYY'
                      name='from'
                      value={dayjs(props.searchOptions.from)}
                      onChange={(e) => props.handleChange(e, 'from')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='to'>To</CustomInputLabel>
                    <CustomDatePicker
                      slotProps={{
                        textField: {
                          ...InputProps,
                          id: 'to',
                          placeholder: 'Date',
                          fullWidth: true
                        },
                      }}
                      format='DD MMM YYYY'
                      name='to'
                      value={dayjs(props.searchOptions.to)}
                      onChange={(e) => props.handleChange(e, 'to')}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.actionGroup}>
                    <CustomButton size='small' fullWidth variant='contained' onClick={props.importFlights}>Import Flights</CustomButton>
                  </div>
                </Grid>
              </Grid>
            </div>

            <div className={developerStyles.importBlock}>
              <Typography component='h3' className={developerStyles.blockTitle}>Clear Flight</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='flight_no'>Flight No.</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='flight_no'
                      name='flight_no'
                      value={props.searchOptions.flight_no}
                      onChange={(e) => props.handleChange(e, 'flight_no')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='date'>Date</CustomInputLabel>
                    <CustomDatePicker
                      slotProps={{
                        textField: {
                          ...InputProps,
                          id: 'date',
                          placeholder: 'Date',
                          fullWidth: true
                        },
                      }}
                      format='DD MMM YYYY'
                      name='date'
                      value={dayjs(props.searchOptions.date)}
                      onChange={(e) => props.handleChange(e, 'date')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3/2}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='org'>Org</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='org'
                      name='org'
                      value={props.searchOptions.org}
                      onChange={(e) => props.handleChange(e, 'org')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3/2}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='dest'>Dest</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='dest'
                      name='dest'
                      value={props.searchOptions.dest}
                      onChange={(e) => props.handleChange(e, 'dest')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.actionGroup}>
                    <CustomButton size='small' fullWidth variant='contained' color='error' onClick={props.clearFlights}>Clear Flight</CustomButton>
                  </div>
                </Grid>
              </Grid>
            </div>
          </StyledCard>
        </Grid>
      </Grid>
    </div>
  );
};

export default Developer;